require('./bootstrap');

// Components
require('./components/animation');
require('./components/disclaimer');
require('./components/colorbox');
require('./components/post');
require('./components/utilities');

// Blocks
require('./blocks/accordion');
require('./blocks/content-box');
require('./blocks/masthead');
require('./blocks/responsive-slider');
require('./blocks/stats');
require('./blocks/tabs');
require('./blocks/wp-menu');
